export default {
  /**
   * Lỗi validate
   */
  Validate: 'VALIDATE',

  /**
   * Lỗi số tiền trên chứng từ vượt quá số tiền còn lại trên chứng từ tham chiếu
   */
  ValidateAmountVoucherReference: 'VALIDATE_AMOUNT_VOUCHER_REFERENCE',

  /**
   * Lỗi hết hạn token
   * NHANH3 04.09.2024
   */
  TokenExpired: 'TOKEN_EXPIRED',
};
